export const envParamStringToArray = (param: string): Array<string | number> | null => {
    try {
        return param?.replace(/\[|\]|'/g, '').split(',').map(m => m.trim());
    } catch (error: any) {
        console.log('envParamStringToArray', 'envParamStringToArray', error.message);
    }
    return null;
}
